module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar pdfLink = ((model.pdfFile || [])[0] || {}).url || '';\nvar newsDate = '';\nif(model.date){\nnewsDate = utils.moment(model.date).format(\"Do MMMM YYYY\")\n}\n%>\n<div>\n<%- include('../../project/gallery/gallery', {\nconfig: {\nshowArrows: true,\nhideThumbs: true\n},\nmodel: {\ngalleryImages: model.image,\n_galleryImages: model._image,\n}\n}) %>\n<div class=\"content\">\n<%\nvar title = model.title || model.teaserTitle;\nif(title){\n%><div class=\"title\"><%- title %></div><%\n}\n%>\n<%- model.html %>\n<div class=\"info\">\n<% if (newsDate) { %><div class=\"date\"><div><img src=\"/icons/calendar.svg\" width=\"16\" height=\"18\" alt=\"Icon Datum\"></div><%=newsDate;%></div><% } %>\n<% if (pdfLink) { %><div class=\"file\"><div><img src=\"/icons/pdf.svg\" width=\"15\" height=\"20\" alt=\"Icon PDF\"></div><a href=\"<%=pdfLink;%>\" onclick=\"event.stopPropagation();\" target=\"_blank\">Download PDF</a></div><% } %>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/news/news/news.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var pdfLink = ((model.pdfFile || [])[0] || {}).url || '';
var newsDate = '';
if(model.date){
newsDate = utils.moment(model.date).format("Do MMMM YYYY")
}

    ; __line = 7
    ; __append("\n<div>\n")
    ; __line = 9
    ; __append( include('../../project/gallery/gallery', {
config: {
showArrows: true,
hideThumbs: true
},
model: {
galleryImages: model.image,
_galleryImages: model._image,
}
}) )
    ; __line = 18
    ; __append("\n<div class=\"content\">\n")
    ; __line = 20
    ; 
var title = model.title || model.teaserTitle;
if(title){

    ; __line = 23
    ; __append("<div class=\"title\">")
    ; __append( title )
    ; __append("</div>")
    ; 
}

    ; __line = 25
    ; __append("\n")
    ; __line = 26
    ; __append( model.html )
    ; __append("\n<div class=\"info\">\n")
    ; __line = 28
    ;  if (newsDate) { 
    ; __append("<div class=\"date\"><div><img src=\"/icons/calendar.svg\" width=\"16\" height=\"18\" alt=\"Icon Datum\"></div>")
    ; __append(escapeFn(newsDate))
    ; __append("</div>")
    ;  } 
    ; __append("\n")
    ; __line = 29
    ;  if (pdfLink) { 
    ; __append("<div class=\"file\"><div><img src=\"/icons/pdf.svg\" width=\"15\" height=\"20\" alt=\"Icon PDF\"></div><a href=\"")
    ; __append(escapeFn(pdfLink))
    ; __append("\" onclick=\"event.stopPropagation();\" target=\"_blank\">Download PDF</a></div>")
    ;  } 
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 32
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/news/news/news.ejs

}